import React from "react";
import baseContentLayout from "../shared/base-content/index";
import "./index.scss";
import EditDialog from "./dialog/edit";
import DeleteDialog from "./dialog/delete";
import MyButton from "../shared/buttons/primary";
import * as actions from "../../modules/setting/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import BookingDetail from "./dialog/booking-detail";

const Content = (props) => {
  const LIMIT = 20;
  const [listCustomer, setListCustomer] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [keyword, setKeyword] = React.useState("");
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  const [dialogData, setDialogData] = React.useState({});
  const [editDialogShow, setEditDialogShow] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [resetPagination, setResetPagination] = React.useState(0);
  const [isReset, setIsReset] = React.useState(0);
  const [detailDialogShow, setDetailDialogShow] = React.useState(false);
  const [userBookingId, setUserBookingId] = React.useState({});

  React.useEffect(() => {
    fetchCustomerList();
  }, [currentPage, isReset]);

  const deleteBtnClick = async (data) => {
    await setDialogData(data);
    setDeleteDialogShow(true);
  };

  const fetchCustomerList = () => {
    window
      .axios({
        url: `user/booking_users`,
        method: "get",
        params: {
          shop: props.auth.user.id,
          username: keyword.trim(),
          page: currentPage,
          page_size: LIMIT,
        },
      })
      .then((result) => {
        setListCustomer(result.data);
        setIsLoading(false);
      });
  };

  const onCloseModel = (data) => {
    setEditDialogShow(false);
    if (!window.utils.isEmptyObject(data)) {
      setIsLoading(true);
      fetchCustomerList();
    }
  };

  const onCloseDeleteDialog = (data) => {
    setDeleteDialogShow(false);
    if (!window.utils.isEmptyObject(data)) {
      setIsLoading(true);
      fetchCustomerList();
    }
  };

  const editBtnClick = (data) => {
    setDialogData(data);
    setEditDialogShow(true);
  };

  const handleSearch = () => {
    setIsLoading(true);
    setCurrentPage(1);
    setResetPagination(resetPagination + 1);
    setIsReset(isReset + 1);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(+selected + 1);
  };

  const handleShowUserBookingDetail = (item) => {
    setDetailDialogShow(true);
    setUserBookingId(item.id);
  };

  const onCloseBookingUserDetail = () => {
    setDetailDialogShow(false);
    setUserBookingId(null);
  };

  const renderEmptyData = () => {
    return (
      <tr>
        <td colSpan="5">ユーザーが有りません</td>
      </tr>
    );
  };

  const renderPagination = () => {
    const isShowPagination = listCustomer.count > LIMIT;
    if (!isShowPagination) return null;
    return (
      <ReactPaginate
        key={resetPagination}
        previousLabel={<span className="material-icons">chevron_left</span>}
        nextLabel={<span className="material-icons">chevron_right</span>}
        disabledClassName={"navigation-disabled"}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={Math.ceil(listCustomer.count / LIMIT) || 1}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"my-pagination"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"}
      />
    );
  };

  const renderTableButton = (item) => {
    return (
      <>
        <MyButton myVariant="edit" onClick={() => editBtnClick(item)}>
          編集
        </MyButton>
        <MyButton
          className="mx-2"
          myVariant="delete"
          onClick={() => deleteBtnClick(item)}
        >
          削除
        </MyButton>
        <MyButton
          myVariant="detail"
          onClick={() => handleShowUserBookingDetail(item)}
        >
          予約履歴
        </MyButton>
      </>
    );
  };

  const renderUserName = (item) => {
    return window._.truncate(item.username || item.full_name, {
      length: 30,
      omission: "...",
    });
  };

  const renderTableRow = () => {
    const tableData = listCustomer.results;
    if (!tableData?.length) return renderEmptyData();

    return tableData?.map((item) => (
      <tr key={item.id}>
        <td>{renderUserName(item)}</td>
        <td>{item.email}</td>
        <td>{item.phone_number}</td>
        <td>{item.booking_count}</td>
        <td>{item.actual_visit_count}</td>
        <td>{item.memo}</td>
        <td className="buttons">{renderTableButton(item)}</td>
      </tr>
    ));
  };

  const renderPageTable = () => {
    return (
      <>
        <div className="history__table table-customer__table">
          <table className="table">
            <thead className="">
              <tr>
                <th scope="col" className="col-fullname">
                  ユーザー名
                </th>
                <th scope="col" className="col-email">
                  メール
                </th>
                <th scope="col" className="col-phone-number">
                  電話番号
                </th>
                <th scope="col" className="col-booking-count">
                  予約回数
                </th>
                <th scope="col" className="col-actual-visit-count">
                  来店回数
                </th>
                <th scope="col" className="col-memo">
                  メモ
                </th>
                <th scope="col" className="col-activity">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>{renderTableRow()}</tbody>
          </table>
          {renderPagination()}
        </div>
      </>
    );
  };

  const renderLoading = () => {
    return (
      <div className="loader-wrapper">
        <div className="loader">Loading...</div>
      </div>
    );
  };

  const renderPageModal = () => {
    return (
      <>
        {editDialogShow && (
          <EditDialog
            show={editDialogShow}
            onclose={onCloseModel}
            detailData={dialogData}
          />
        )}
        {deleteDialogShow && (
          <DeleteDialog
            isShow={deleteDialogShow}
            onClose={onCloseDeleteDialog}
            data={dialogData}
          />
        )}
        {detailDialogShow && (
          <BookingDetail
            show={detailDialogShow}
            userId={userBookingId}
            onCloseModalDetail={onCloseBookingUserDetail}
          />
        )}
      </>
    );
  };

  const renderMainContent = () => {
    if (isLoading) return renderLoading();
    return renderPageTable();
  };

  return (
    <div className="table-seat">
      <div className="table-seat__search mb-4 d-flex align-items-center">
        <div className="me-3">
          <div className="table__search">
            <div className="form-group d-inline-block me-3">
              <input
                type="text"
                className="form-control no-box-shadow d-inline-block"
                placeholder="ユーザー名"
                value={keyword}
                onChange={(e) => {
                  const { value } = e.target;
                  setKeyword(value);
                }}
                onKeyUp={(event) => {
                  if (event.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </div>
            <MyButton myVariant="search" onClick={handleSearch}>
              検索
            </MyButton>
          </div>
        </div>
      </div>
      {renderMainContent()}
      {renderPageModal()}
    </div>
  );
};
const CustomerContent = baseContentLayout(Content);

class index extends React.Component {
  render() {
    return <CustomerContent name="ユーザー一覧" {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(index);
